<script>
import axios from 'axios'
import CloseLockerPromptModal from '@/vcs/_shared/modals/CloseLockerPromptModal.vue'
import ChooseBoxModal from '@/vcs/_shared/modals/ChooseBoxModal.vue'
import ModalMixin from '@/mixins/ModalMixin.js'
import { mapGetters } from 'vuex'

const CLOSE_LOCKER_MESSAGE =
  'Proszę zamknąć skrytkę zanim przypisana zostanie nowa skrytka.'

export default {
  mixins: [ModalMixin],
  data: function () {
    return {
      CloseLockerPromptModal
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  methods: {
    openBoxOrChooseBox() {
      if (this.cp.pickableSizeEnabled) {
        this.openSelectBoxSizeModal()
      } else {
        this.openBox()
      }
    },
    openSelectBoxSizeModal() {
      this.$store.commit('modal/open', {
        cmp: ChooseBoxModal,
        size: 'full',
        callback: this.emitBoxId
      })
    },
    emitBoxId(obj) {
      let { boxId } = obj
      console.log('boxId', boxId)

      if (this.$dev) {
        this.$emit('boxAssigned', '1e41b1b4-fe90-4ffc-bc90-21bfebc511c9')
        return
      }
      this.$emit('boxAssigned', boxId)
    },
    openBox() {
      this.$blockUI()
      // INFO: na podstawie deliveryRequestId wywoluje /open_box
      // :response - DR z box_id
      // :$dev - symulujemy zachowanie po tym jak dostaniemy response z boxId
      if (this.$dev) {
        this.$emit('boxAssigned', '1e41b1b4-fe90-4ffc-bc90-21bfebc511c9')
        this.$unblockUI()
        return
      }

      let token = window.localStorage.getItem('delivery_request_token')
      axios({
        method: 'put',
        url: `/delivery_requests/${this.$route.params.id}/open_box`,
        params: { same_size: false },
        headers: {
          common: {
            Authorization: `Bearer ${token}`
          }
        }
      })
        .then((response) => {
          this.$emit('boxAssigned', response.data.boxId) // fires callback, updates boxId
        })
        .catch((error) => {
          let errorCode = Object.values(
            (((error || {}).response || {}).data || {}).errors
          )
          if (errorCode == 'dr:9') {
            this.openCloseLockerPromptModal(CLOSE_LOCKER_MESSAGE, this.openBox)
          } else if (errorCode == 'dr:10') {
            this.openNoAvailableBoxesModal()
          } else {
            this.$errorHumanized()
          }
        })
        .finally(() => {
          this.$unblockUI()
        })
    }
  }
}
</script>

<template lang="pug">
button.btn.btn-light.text-primary(type="button" v-ea-click="openBoxOrChooseBox") {{ $t('d.confirmation.changeLockerButton') }}
</template>
